import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'maki-youtube';
  env = environment;

  constructor(private router: Router) { }

  isRootRouteActive(): boolean {
    console.log(this.env);
    return this.router.url === '/';
  }
}
